export default "__VITE_ASSET__DmWF1eX2__"